import DataForms from './../../data/main/config/setup/form/forms'
import DataMaterials from './../../data/main/config/setup/material/materials'
import DataRand from './../../data/main/config/setup/rand/randArt'
import DataShipping from './../../data/main/config/shippingCosts'

const roundPrice = (value) => {
  return Math.round((value + Number.EPSILON) * 100) / 100
}

const state = {
  calcFormFactor: null,
  calcSides: {},
  calcSidesRand: {
    0: DataRand.randArt.schnittkante.title.name,
    1: DataRand.randArt.schnittkante.title.name,
    2: DataRand.randArt.schnittkante.title.name,
    3: DataRand.randArt.schnittkante.title.name
  },
  calcMaterialPrice: null,
  calcOuterArea: null,
  calcOesenAnzahl: [],
  calcOesenSides: [],
  calcOesenAnzahlTotal: null,
  calcOesenTotal: null,
  calcSaumSides: [],
  calcSaumSidesTotal: null,
  calcSaumTotal: null,
  calcHohlsaumSides: [],
  calcHohlsaumSidesTotal: null,
  calcHohlsaumTotal: null,
  calcKederSides: [],
  calcKederSidesTotal: null,
  calcKederTotal: null,
  calcUnitPrice: null,
  calcMinOrder: null,
  calcShippingCost: null,
  calcDeliveryTime: null
}

const mutations = {
  'SET_CALC_FORMFACTOR' (state, formFactor) {
    state.calcFormFactor = formFactor
  },
  'SET_CALC_SIDES' (state, formConfig) {
    state.calcSides = {}
    switch (formConfig.type) {
      case DataForms.forms.rechteck.type[0].name:
        state.calcSides[0] = formConfig.size.a
        state.calcSides[1] = formConfig.size.b
        state.calcSides[2] = formConfig.size.a
        state.calcSides[3] = formConfig.size.b
        break
      case DataForms.forms.dreieck.type[0].name:
        state.calcSides[0] = formConfig.size.a
        state.calcSides[1] = Math.sqrt(Math.pow(formConfig.size.a / 2, 2) + Math.pow(formConfig.size.h, 2))
        state.calcSides[2] = Math.sqrt(Math.pow(formConfig.size.a / 2, 2) + Math.pow(formConfig.size.h, 2))
        break
      case DataForms.forms.dreieck.type[1].name:
        state.calcSides[0] = formConfig.size.a
        state.calcSides[1] = formConfig.size.a
        state.calcSides[2] = formConfig.size.a
        break
      case DataForms.forms.dreieck.type[2].name:
        state.calcSides[0] = formConfig.size.a
        state.calcSides[1] = formConfig.size.b
        state.calcSides[2] = Math.sqrt(Math.pow(formConfig.size.a, 2) + Math.pow(formConfig.size.b, 2))
        break
      case DataForms.forms.trapez.type[0].name:
        state.calcSides[0] = formConfig.size.a
        state.calcSides[1] = Math.sqrt(Math.pow((formConfig.size.a - formConfig.size.c) / 2, 2) + Math.pow(formConfig.size.h, 2))
        state.calcSides[2] = formConfig.size.c
        state.calcSides[3] = Math.sqrt(Math.pow((formConfig.size.a - formConfig.size.c) / 2, 2) + Math.pow(formConfig.size.h, 2))
        break
      case DataForms.forms.trapez.type[1].name:
        state.calcSides[0] = formConfig.size.a
        state.calcSides[1] = formConfig.size.b
        state.calcSides[2] = formConfig.size.c
        state.calcSides[3] = Math.sqrt(Math.pow((formConfig.size.a - formConfig.size.c), 2) + Math.pow(formConfig.size.b, 2))
        break
      case DataForms.forms.trapez.type[2].name:
        state.calcSides[0] = formConfig.size.a
        state.calcSides[1] = Math.sqrt(Math.pow((formConfig.size.a - formConfig.size.c), 2) + Math.pow(formConfig.size.d, 2))
        state.calcSides[2] = formConfig.size.c
        state.calcSides[3] = formConfig.size.d
        break
      case DataForms.forms.trapez.type[3].name:
        state.calcSides[0] = formConfig.size.a
        state.calcSides[1] = formConfig.size.b
        state.calcSides[2] = Math.sqrt(Math.pow((formConfig.size.b - formConfig.size.d), 2) + Math.pow(formConfig.size.a, 2))
        state.calcSides[3] = formConfig.size.d
        break
      case DataForms.forms.trapez.type[4].name:
        state.calcSides[0] = formConfig.size.a
        state.calcSides[1] = formConfig.size.b
        state.calcSides[2] = Math.sqrt(Math.pow((formConfig.size.d - formConfig.size.b), 2) + Math.pow(formConfig.size.a, 2))
        state.calcSides[3] = formConfig.size.d
        break
      case DataForms.forms.trapez.type[5].name:
        state.calcSides[0] = formConfig.size.a
        state.calcSides[1] = formConfig.size.b
        state.calcSides[2] = formConfig.size.c
        state.calcSides[3] = Math.sqrt(Math.pow((formConfig.size.a - formConfig.size.c), 2) + Math.pow((formConfig.size.b - formConfig.size.e), 2))
        state.calcSides[4] = formConfig.size.e
        break
      case DataForms.forms.trapez.type[6].name:
        state.calcSides[0] = formConfig.size.a
        state.calcSides[1] = formConfig.size.b
        state.calcSides[2] = Math.sqrt(Math.pow((formConfig.size.a - formConfig.size.d), 2) + Math.pow((formConfig.size.e - formConfig.size.b), 2))
        state.calcSides[3] = formConfig.size.d
        state.calcSides[4] = formConfig.size.e
        break
      case DataForms.forms.kreis.type[0].name:
        state.calcSides[0] = Math.PI * formConfig.size.d
        break
      case DataForms.forms.halbkreis.type[0].name:
        state.calcSides[0] = formConfig.size.d
        state.calcSides[1] = Math.PI * (formConfig.size.d / 2)
        break
      case DataForms.forms.polygon.type[0].name:
        state.calcSides[0] = formConfig.size.a
        state.calcSides[1] = formConfig.size.a
        state.calcSides[2] = formConfig.size.a
        state.calcSides[3] = formConfig.size.a
        state.calcSides[4] = formConfig.size.a
        break
      case DataForms.forms.polygon.type[1].name:
        state.calcSides[0] = formConfig.size.a
        state.calcSides[1] = formConfig.size.a
        state.calcSides[2] = formConfig.size.a
        state.calcSides[3] = formConfig.size.a
        state.calcSides[4] = formConfig.size.a
        state.calcSides[5] = formConfig.size.a
        break
      case DataForms.forms.polygon.type[2].name:
        state.calcSides[0] = formConfig.size.a
        state.calcSides[1] = formConfig.size.a
        state.calcSides[2] = formConfig.size.a
        state.calcSides[3] = formConfig.size.a
        state.calcSides[4] = formConfig.size.a
        state.calcSides[5] = formConfig.size.a
        state.calcSides[6] = formConfig.size.a
        break
      case DataForms.forms.polygon.type[3].name:
        state.calcSides[0] = formConfig.size.a
        state.calcSides[1] = formConfig.size.a
        state.calcSides[2] = formConfig.size.a
        state.calcSides[3] = formConfig.size.a
        state.calcSides[4] = formConfig.size.a
        state.calcSides[5] = formConfig.size.a
        state.calcSides[6] = formConfig.size.a
        state.calcSides[7] = formConfig.size.a
    }
  },
  'SET_CALC_OUTERAREA' (state, formConfig) {
    switch (formConfig.type) {
      case DataForms.forms.rechteck.type[0].name:
        state.calcOuterArea = (formConfig.size.a / 100) * (formConfig.size.b / 100)
        break
      case DataForms.forms.dreieck.type[0].name:
        state.calcOuterArea = (formConfig.size.a / 100) * (formConfig.size.h / 100)
        break
      case DataForms.forms.dreieck.type[1].name:
        state.calcOuterArea = (formConfig.size.a / 100) * ((formConfig.size.a / 100) / 2 * Math.sqrt(3))
        break
      case DataForms.forms.dreieck.type[2].name:
        state.calcOuterArea = (formConfig.size.a / 100) * (formConfig.size.b / 100)
        break
      case DataForms.forms.trapez.type[0].name:
        state.calcOuterArea = (Math.max(formConfig.size.a, formConfig.size.c) / 100) * (formConfig.size.h / 100)
        break
      case DataForms.forms.trapez.type[1].name:
        state.calcOuterArea = (Math.max(formConfig.size.a, formConfig.size.c) / 100) * (formConfig.size.b / 100)
        break
      case DataForms.forms.trapez.type[2].name:
        state.calcOuterArea = (Math.max(formConfig.size.a, formConfig.size.c) / 100) * (formConfig.size.d / 100)
        break
      case DataForms.forms.trapez.type[3].name:
        state.calcOuterArea = (formConfig.size.a / 100) * (Math.max(formConfig.size.b, formConfig.size.d) / 100)
        break
      case DataForms.forms.trapez.type[4].name:
        state.calcOuterArea = (formConfig.size.a / 100) * (Math.max(formConfig.size.b, formConfig.size.d) / 100)
        break
      case DataForms.forms.trapez.type[5].name:
        state.calcOuterArea = (Math.max(formConfig.size.a, formConfig.size.c) / 100) * (Math.max(formConfig.size.b, formConfig.size.e) / 100)
        break
      case DataForms.forms.trapez.type[6].name:
        state.calcOuterArea = (Math.max(formConfig.size.a, formConfig.size.d) / 100) * (Math.max(formConfig.size.e, formConfig.size.b) / 100)
        break
      case DataForms.forms.kreis.type[0].name:
        state.calcOuterArea = (formConfig.size.d / 100) * (formConfig.size.d / 100)
        break
      case DataForms.forms.halbkreis.type[0].name:
        state.calcOuterArea = (formConfig.size.d / 100) * ((formConfig.size.d / 2) / 100)
        break
      case DataForms.forms.polygon.type[0].name:
        state.calcOuterArea = Math.pow(((formConfig.size.a / 100) / 10) * Math.sqrt(50 + 10 * Math.sqrt(5)) * 2, 2)
        break
      case DataForms.forms.polygon.type[1].name:
        state.calcOuterArea = Math.pow((formConfig.size.a / 100) * 2, 2)
        break
      case DataForms.forms.polygon.type[2].name:
        state.calcOuterArea = Math.pow((formConfig.size.a / 100) / (2 * Math.sin(Math.PI / 7)) * 2, 2)
        break
      case DataForms.forms.polygon.type[3].name:
        state.calcOuterArea = Math.pow(1 / 2 * Math.sqrt(4 + 2 * Math.sqrt(2)) * (formConfig.size.a / 100) * 2, 2)
    }
  },
  'SET_CALC_UNIT_PRICE' (state, checkHohlschnitt) {
    if (checkHohlschnitt) {
      state.calcUnitPrice = roundPrice(Math.max(state.calcMinOrder, state.calcMaterialPrice * state.calcOuterArea * state.calcFormFactor) + state.calcOuterArea * DataRand.randArt.hohlschnitt.factor)
    } else {
      state.calcUnitPrice = roundPrice(Math.max(state.calcMinOrder, state.calcMaterialPrice * state.calcOuterArea * state.calcFormFactor) + state.calcSaumTotal + state.calcOesenTotal + state.calcHohlsaumTotal + state.calcKederTotal)
    }
  },
  'CLEAR_CALC' (state) {
    state.calcFormFactor = DataForms.forms.rechteck.type[0].factor
    state.calcSides = {}
    state.calcSidesRand = {
      0: DataRand.randArt.schnittkante.title.name,
      1: DataRand.randArt.schnittkante.title.name,
      2: DataRand.randArt.schnittkante.title.name,
      3: DataRand.randArt.schnittkante.title.name
    }
    state.calcMaterialPrice = DataMaterials.materials.pvc600.price
    state.calcOuterArea = null
    state.calcUnitPrice = state.calcMinOrder
    state.calcDeliveryTime = DataMaterials.materials.pvc600.delivery
  },
  'SET_CALC_MATERIAL_PRICE' (state, materialPrice) {
    state.calcMaterialPrice = materialPrice
  },
  'SET_CALC_DELIVERY_TIME' (state, deliveryTime) {
    state.calcDeliveryTime = deliveryTime
  },
  'SET_CALC_RAND' (state, config) {
    state.calcOesenAnzahl.splice(0, state.calcOesenAnzahl.length)
    state.calcOesenSides.splice(0, state.calcOesenSides.length)
    state.calcSaumSides.splice(0, state.calcSaumSides.length)
    state.calcHohlsaumSides.splice(0, state.calcHohlsaumSides.length)
    state.calcKederSides.splice(0, state.calcKederSides.length)
    if (Object.values(state.calcSidesRand).includes(DataRand.randArt.saum.titleSaum.name)) {
      Object.entries(state.calcSidesRand).filter(el => el[1] === DataRand.randArt.saum.titleSaum.name).forEach(el => {
        state.calcSaumSides.push(Number(state.calcSides[el[0]]))
        state.calcOesenAnzahl.push(config.sides[el[0]].oesenAnzahl)
        state.calcOesenSides.push(el[0])
      })
      const copyOesenAnzahl = [...state.calcOesenAnzahl]
      if (state.calcOesenSides.length > 1) {
        if (
          Number(state.calcOesenSides[state.calcOesenSides.length - 1]) === (Object.values(state.calcSidesRand).length - 1) &&
          Number(state.calcOesenSides[0]) === 0 &&
          state.calcOesenAnzahl[state.calcOesenAnzahl.length - 1] >= 2 &&
          state.calcOesenAnzahl[0] >= 2
        ) {
          copyOesenAnzahl.splice(copyOesenAnzahl.length - 1, 1, copyOesenAnzahl[copyOesenAnzahl.length - 1] - 1)
        }
        for (let i = 1; i < state.calcOesenSides.length; i++) {
          if (
            Number(state.calcOesenSides[i]) - 1 === Number(state.calcOesenSides[i - 1]) &&
            state.calcOesenAnzahl[i] >= 2 &&
            state.calcOesenAnzahl[i - 1] >= 2
          ) {
            copyOesenAnzahl.splice(i, 1, copyOesenAnzahl[i] - 1)
          }
        }
      }
      copyOesenAnzahl.forEach((el, index) => {
        state.calcOesenAnzahl.splice(index, 1, el)
      })
    }
    if (Object.values(state.calcSidesRand).includes(DataRand.randArt.hohlsaum.title.name)) {
      Object.entries(state.calcSidesRand).filter(el => el[1] === DataRand.randArt.hohlsaum.title.name).forEach(el => {
        state.calcHohlsaumSides.push(Number(state.calcSides[el[0]]))
      })
    }
    if (Object.values(state.calcSidesRand).includes(DataRand.randArt.keder.title.name)) {
      Object.entries(state.calcSidesRand).filter(el => el[1] === DataRand.randArt.keder.title.name).forEach(el => {
        state.calcKederSides.push(Number(state.calcSides[el[0]]))
      })
    }
    state.calcOesenAnzahlTotal = state.calcOesenAnzahl.reduce((a, b) => { return a + b }, 0)
    state.calcOesenTotal = roundPrice(config.priceOesen * state.calcOesenAnzahlTotal + config.factorDrehverschluss * config.priceOesen * state.calcOesenAnzahlTotal)
    state.calcSaumSidesTotal = state.calcSaumSides.reduce((a, b) => { return a + b }, 0) / 100
    state.calcSaumTotal = roundPrice(state.calcSaumSidesTotal * config.priceSaum)
    state.calcHohlsaumSidesTotal = state.calcHohlsaumSides.reduce((a, b) => { return a + b }, 0) / 100
    state.calcHohlsaumTotal = roundPrice(state.calcHohlsaumSidesTotal * config.priceHohlsaum)
    state.calcKederSidesTotal = state.calcKederSides.reduce((a, b) => { return a + b }, 0) / 100
    state.calcKederTotal = roundPrice(state.calcKederSidesTotal * config.priceKeder)
  },
  'INIT_CALC_SIDES_RAND' (state, countSides) {
    state.calcSidesRand = {}
    for (let i = 0; i < countSides; i++) {
      state.calcSidesRand[i] = DataRand.randArt.schnittkante.title.name
    }
  },
  'CLEAR_CALC_SIDES_RAND' (state) {
    for (var el in state.calcSidesRand) {
      state.calcSidesRand[el] = DataRand.randArt.schnittkante.title.name
    }
  },
  'SET_CALC_SIDES_RAND' (state, randType) {
    state.calcSidesRand[randType.side] = randType.type
  },
  'SET_CALC_SIDES_RAND_HOHLSCHNITT' (state) {
    for (var el in state.calcSidesRand) {
      state.calcSidesRand[el] = DataRand.randArt.hohlschnitt.title.name
    }
  },
  'SET_CALC_INITIAL' (state, initValues) {
    state.calcFormFactor = initValues.formFactor
    state.calcMaterialPrice = initValues.materialPrice
    state.calcMinOrder = initValues.minOrder
    state.calcUnitPrice = initValues.minOrder
    state.calcDeliveryTime = initValues.deliveryTime
  },
  'SET_CALC_SHIPPING' (state, shippingConfig) {
    const zip = shippingConfig.checkDelivery ? parseInt(shippingConfig.deliveryZip) : parseInt(shippingConfig.billingZip)
    const country = shippingConfig.checkDelivery ? shippingConfig.deliveryCountry : shippingConfig.billingCountry
    if (country === DataShipping.shippingCosts.country.germany.title) {
      state.calcShippingCost = DataShipping.shippingCosts.country.germany.types.packet.price + (shippingConfig.islandZip.includes(zip) ? DataShipping.shippingCosts.country.germany.types.island.price : 0)
    } else {
      state.calcShippingCost = DataShipping.shippingCosts.country.eu.types.packet.price
    }
  }
}

const actions = {
  setCalcFactor: ({ commit }, formFactor) => {
    commit('SET_CALC_FORMFACTOR', formFactor)
  },
  setCalcForm: ({ commit, rootState }, formConfig) => {
    commit('SET_CALC_SIDES', formConfig)
    commit('SET_CALC_OUTERAREA', formConfig)
    commit('SET_CALC_RAND', {
      sides: rootState.rand.randSides,
      priceOesen: rootState.rand.selectedOesenArt.price,
      factorDrehverschluss: rootState.rand.selectedDrehverschluss.factor,
      priceSaum: DataRand.randArt.saum.price,
      priceHohlsaum: rootState.rand.selectedBreiteHohlsaum.price,
      priceKeder: rootState.rand.selectedKederGroesse.price
    })
    commit('SET_CALC_UNIT_PRICE', rootState.rand.selectedHohlschnitt)
  },
  setCalcMaterial: ({ commit, rootState }, materialConfig) => {
    commit('SET_CALC_MATERIAL_PRICE', materialConfig.price)
    commit('SET_CALC_DELIVERY_TIME', materialConfig.deliveryTime)
    commit('SET_CALC_RAND', {
      sides: rootState.rand.randSides,
      priceOesen: rootState.rand.selectedOesenArt.price,
      factorDrehverschluss: rootState.rand.selectedDrehverschluss.factor,
      priceSaum: DataRand.randArt.saum.price,
      priceHohlsaum: rootState.rand.selectedBreiteHohlsaum.price,
      priceKeder: rootState.rand.selectedKederGroesse.price
    })
    commit('SET_CALC_UNIT_PRICE', rootState.rand.selectedHohlschnitt)
  },
  setCalcRand: ({ commit, rootState }) => {
    commit('SET_CALC_RAND', {
      sides: rootState.rand.randSides,
      priceOesen: rootState.rand.selectedOesenArt.price,
      factorDrehverschluss: rootState.rand.selectedDrehverschluss.factor,
      priceSaum: DataRand.randArt.saum.price,
      priceHohlsaum: rootState.rand.selectedBreiteHohlsaum.price,
      priceKeder: rootState.rand.selectedKederGroesse.price
    })
    commit('SET_CALC_UNIT_PRICE', rootState.rand.selectedHohlschnitt)
  },
  setCalcUnitPrice: ({ commit, rootState }) => {
    commit('SET_CALC_UNIT_PRICE', rootState.rand.selectedHohlschnitt)
  },
  initCalcSidesRand: ({ commit }, countSides) => {
    commit('INIT_CALC_SIDES_RAND', countSides)
  },
  setCalcSidesRand: ({ commit }, randType) => {
    commit('SET_CALC_SIDES_RAND', randType)
  },
  clearCalcSidesRand: ({ commit, rootState }) => {
    commit('CLEAR_CALC_SIDES_RAND')
    commit('SET_CALC_RAND', {
      sides: rootState.rand.randSides,
      priceOesen: rootState.rand.selectedOesenArt.price,
      factorDrehverschluss: rootState.rand.selectedDrehverschluss.factor,
      priceSaum: DataRand.randArt.saum.price,
      priceHohlsaum: rootState.rand.selectedBreiteHohlsaum.price,
      priceKeder: rootState.rand.selectedKederGroesse.price
    })
    commit('SET_CALC_UNIT_PRICE', rootState.rand.selectedHohlschnitt)
  },
  clearCalc: ({ commit }) => {
    commit('CLEAR_CALC')
  },
  setCalcSidesRandHohlschnitt: ({ commit, rootState }) => {
    if (rootState.rand.selectedHohlschnitt) {
      commit('SET_CALC_SIDES_RAND_HOHLSCHNITT')
    } else {
      commit('CLEAR_CALC_SIDES_RAND')
    }
  },
  setCalcInitial: ({ commit }, initValues) => {
    commit('SET_CALC_INITIAL', initValues)
  },
  setCalcShipping: ({ commit, rootState }, islandZip) => {
    commit('SET_CALC_SHIPPING', {
      checkDelivery: rootState.client.checkDelivery,
      billingCountry: rootState.client.billingAddress.country.name,
      billingZip: rootState.client.billingAddress.zip,
      deliveryCountry: rootState.client.deliveryAddress.country.name,
      deliveryZip: rootState.client.deliveryAddress.zip,
      islandZip
    })
  }
}

const getters = {
  calcSides: state => {
    return state.calcSides
  },
  calcFormFactor: state => {
    return state.calcFormFactor
  },
  calcSaumSidesTotal: state => {
    return state.calcSaumSidesTotal
  },
  calcOesenAnzahlTotal: state => {
    return state.calcOesenAnzahlTotal
  },
  calcHohlsaumSidesTotal: state => {
    return state.calcHohlsaumSidesTotal
  },
  calcKederSidesTotal: state => {
    return state.calcKederSidesTotal
  },
  calcDeliveryTime: state => {
    return state.calcDeliveryTime
  },
  calcShippingCost: state => {
    return state.calcShippingCost
  },
  calcOuterArea: (state, getters) => {
    return state.calcOuterArea
  },
  calcUnitPriceBrutto: state => {
    return state.calcUnitPrice
  },
  isNetto: (state, getters, rootState) => {
    return rootState.VAT ? rootState.VAT.checkVAT : false
  },
  currentVatRate: (state, getters, rootState) => {
    return rootState.VAT ? rootState.VAT.VATRate : 0.19
  },
  calcSaumTotal: (state, getters) => {
    return getters.isNetto ? roundPrice(state.calcSaumTotal / (1 + getters.currentVatRate)) : state.calcSaumTotal
  },
  calcOesenTotal: (state, getters) => {
    return getters.isNetto ? roundPrice(state.calcOesenTotal / (1 + getters.currentVatRate)) : state.calcOesenTotal
  },
  calcHohlsaumTotal: (state, getters) => {
    return getters.isNetto ? roundPrice(state.calcHohlsaumTotal / (1 + getters.currentVatRate)) : state.calcHohlsaumTotal
  },
  calcKederTotal: (state, getters) => {
    return getters.isNetto ? roundPrice(state.calcKederTotal / (1 + getters.currentVatRate)) : state.calcKederTotal
  },
  calcUnitPrice: (state, getters) => {
    return getters.isNetto ? roundPrice(state.calcUnitPrice / (1 + getters.currentVatRate)) : state.calcUnitPrice
  },
  calcSumPriceVAT: (state, getters, rootState) => {
    let sumTotal = 0
    if (rootState.configuration && rootState.configuration.configurationList) {
      rootState.configuration.configurationList.forEach(el => {
        let singlePrice = el.price
        if (getters.isNetto) {
          singlePrice = roundPrice(singlePrice / (1 + getters.currentVatRate))
        } else {
          singlePrice = roundPrice(singlePrice)
        }
        sumTotal += (singlePrice * el.quantity)
      })
    }
    return roundPrice(sumTotal)
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
